export default __webpack_public_path__ + "static/media/forestly-noexpl-01_EN.8872cb58.png";